import { render, staticRenderFns } from "./ListaDeArtigos.vue?vue&type=template&id=f6cf7e3c&"
import script from "./ListaDeArtigos.vue?vue&type=script&lang=js&"
export * from "./ListaDeArtigos.vue?vue&type=script&lang=js&"
import style0 from "./ListaDeArtigos.vue?vue&type=style&index=0&id=f6cf7e3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports